import api from "@/services/api";

export async function loadProfile(username) {
  try {
    const res = await api.get("/api/profile", {
      params: {
        username: username,
      },
    });

    return {
      status: res.status,
      data: res.data,
    };
  } catch (error) {
    console.log("ERROR PROFILE:", error);

    return {
      status: error.response?.status ?? 500,
      data: error.response?.data ?? null,
      error: error,
    };
  }
}

export async function insertprofile() {
  try {
    const res = await api.post("/api/perusahaan/insertdata", {});

    return res;
  } catch (error) {
    console.log("ERROR PROFILE:", error);

    return {
      status: error.response?.status ?? 500,
      data: error.response?.data ?? null,
      error: error,
    };
  }
}
